(() => {
  const link = document.querySelector('[data-ca-reviews-link]');
  if (!link || new URL(link.href).pathname !== location.pathname) return;
  const connect = () => {
    const reviews = document.querySelector('.jdgm-testimonials-carousel');
    if (!reviews || reviews.getBoundingClientRect().height < 100) return false;
    reviews.id = 'ca-customer-reviews';
    reviews.style.scrollMarginTop = '96px';
    if (location.hash === '#ca-customer-reviews') {
      const scroll = () => requestAnimationFrame(() => requestAnimationFrame(() => reviews.scrollIntoView()));
      if (document.readyState === 'complete') scroll();
      else window.addEventListener('load', scroll, { once: true });
    }
    return true;
  };
  if (connect()) return;
  const observer = new MutationObserver(() => { if (connect()) observer.disconnect(); });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
})();
